import { constants } from "@newsela/angelou";

export const headerActionsContainerStyles = {
  display: "flex",
};

export const bookmarkIconStyles = {
  root: {
    color: constants.colors.ui.neutral[500],
  },
};

export const shareActionWrapperStyles = {
  height: "24px",
  width: "24px",
  position: "relative",
  top: "-2px",
  cursor: "pointer",
  marginLeft: "16px",
  marginBottom: "20px",
} as const;

export const popupOverridesStyles = {
  root: {
    zIndex: 3,
  },
};
